import { useEffect } from "react"
import { withRouter } from "react-router-dom"
import { requestLogin , requestDeveloperLogin} from "../../constants/constant"
/**
 * Just redirects to SSO sign in page.
 */
const SignInRedirect = ({whichSignIn = "analytics"}) => {
  useEffect(() => {
    switch(whichSignIn){
      case "analytics":
        requestLogin()
        break;
      case "developers":
        requestDeveloperLogin()
        break;
      default:
        requestLogin()
    }
    // requestLogin()
    // requestDeveloperLogin()
  }, [])
  return <div style={{ height: "100vh" }}></div>
}
export default withRouter(SignInRedirect)
